import { useNavigate } from 'react-router-dom';

export const NavigateSolicitacao = ({ row }) => {
  const navigate = useNavigate();

  const handleEditClick = () => {
    const { id } = row;

    if (!id) return;

    navigate(`/Solicitacao/${id}`);
  };

  return (
    <i
      className="fa-solid fa-edit fs-6"
      onClick={handleEditClick}
      style={{
        color: '#2b97be',
        cursor: 'pointer',
      }}
      title="Clique para editar a solicitação"
    />
  );
};
